import Backbone from 'backbone';

import GetPRTNROrderTotalByOrderId from '../services/GetPRTNROrderTotalByOrderId';
import GetOFPRTNRByOrderId from '../services/GetOFPRTNRByOrderId';
import GetOFMFDMaintenanceByOrderId from '../services/GetOFMFDMaintenanceByOrderId';
import GetOFCONUSWideByOrderId from '../services/GetOFCONUSWideByOrderId';
import GetOfWideFormatByOrderId from '../services/GetOfWideFormatByOrderId';
import GetOFCONUSDesktopByOrderId from '../services/GetOFCONUSDesktopByOrderId';
import GetMFDOrderByOrderId from '../services/GetOFMFDOrderByOrderId';
import GetOFMFDRelocationByOrderId from '../services/GetOFMFDRelocationByOrderId';
import GetOFConusByOrderId from '../services/GetOFConusByOrderId';
import GetOFOCONUSByOrderId from '../services/GetOFOCONUSByOrderId';
import GetCustomerOrderSummaryByOrderID from '../services/GetCustomerOrderSummaryByOrderID';
import GetAllOrderFormDataByOrderId from '../services/GetAllOrderFormDataByOrderId';
import OrderSummaryView from '../views/OrderSummaryView/OrderSummaryView';

export default async function loadOrderSummaryView(orderDetails) {
  let order;
  let orderTotals;
  switch (orderDetails.orderTypeId) {
    case '1':
    case '3':
      order = await GetMFDOrderByOrderId(orderDetails.orderId);
      break;
    case '2':
    case '13':
    case '14':
    case '15':
      orderTotals = await GetPRTNROrderTotalByOrderId(orderDetails.orderId);
      order = await GetOFPRTNRByOrderId(orderDetails.orderId);
      break;

    case '4':
      order = await GetOFMFDMaintenanceByOrderId(orderDetails.orderId);
      break;

    case '5':
      order = await GetOFCONUSWideByOrderId(orderDetails.orderId);
      break;

    case '6':
    case '10':
    case '11':
      order = await GetOFCONUSDesktopByOrderId(orderDetails.orderId);
      break;

    case '12':
      order = await GetOFMFDRelocationByOrderId(orderDetails.orderId);
      break;

    case '16':
    case '20':
      order = await GetOFConusByOrderId(orderDetails.orderId);
      break;

    case '17':
      order = await GetOfWideFormatByOrderId(orderDetails.orderId);
      break;

    case '18':
    case '21':
      order = await GetOFOCONUSByOrderId(orderDetails.orderId);
      break;

    case '22':
    case '23':
    case '24':
    case '25':
    case '26':
      order = await GetCustomerOrderSummaryByOrderID(orderDetails.orderId);
      break;
    case '19':
      order = await GetAllOrderFormDataByOrderId(orderDetails.orderId);
      break;
  }

  return new OrderSummaryView({
    model: new Backbone.Model({
      orderDetails,
      order,
      orderTotals
    })
  });
}
